var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TransactionDataField } from "./TransactionDataField";
export class OneTransactionData {
  constructor(_data) {
    /**
     */
    __publicField(this, "Fields");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof OneTransactionData
     */
    __publicField(this, "$type", "V1.GenerationConfiguration.OneTransactionData");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Fields"] && _data["Fields"].constructor === Array) {
        this.Fields = [];
        for (let item of _data["Fields"]) {
          const fields_ = new TransactionDataField();
          this.Fields.push(fields_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.Fields && this.Fields.constructor === Array) {
      _data["Fields"] = [];
      for (let item of this.Fields) {
        _data["Fields"].push(item.toJSON());
      }
    }
    return _data;
  }
}
